function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { stringify } from "query-string";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
const ProtectedRoute = (props)=>{
    const { toSignUpInstead , conditions  } = props, rest = _objectWithoutProperties(props, [
        "toSignUpInstead",
        "conditions"
    ]);
    const currentUser = useCurrentUser();
    const location = useLocation();
    const search = stringify({
        next: location.pathname + location.search
    });
    const redirectToLogin = useMemo(()=>({
            pathname: "/login",
            search
        }), [
        search
    ]);
    const redirectToSignUp = useMemo(()=>({
            pathname: "/signup",
            search
        }), [
        search
    ]);
    const additionalRedirect = useMemo(()=>{
        if (!conditions) return null;
        const match = conditions.find(({ condition  })=>condition === false);
        return match ? match.ifFail : null;
    }, [
        conditions
    ]);
    if (!currentUser) return /*#__PURE__*/ _jsx(Redirect, {
        to: toSignUpInstead ? redirectToSignUp : redirectToLogin
    });
    if (additionalRedirect) return /*#__PURE__*/ _jsx(Redirect, {
        to: additionalRedirect
    });
    return /*#__PURE__*/ _jsx(Route, _objectSpread({}, rest));
};
export default ProtectedRoute;
